export default {
    add_all_materials_from_warehouse: "Складдан бардык материалдарды кошуу",
    add_good: "Продукция кошуу",
    add_material: "Материалды кошуу",
    add_new: "Жаңыны кошуу",
    adding_new_supplier: "Жаңы жеткирүүчүнү кошуу",
    addition: "Киреше",
    address: "Дареги",
    adjustment: "Тууралоо",
    amount: "Саны",
    amount_of_stock_on_all_warehouses: "Клиниканын бардык скаладдарында бар товарлардын жалпы саны",
    approve: "Бекитүү",
    approved: "Бекитилген",
    are_you_sure_you_want_to_delete_group: "Сиз чындыгында топту жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_kit: "Сиз чындыгында топтомду жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_supplier: "Сиз чындыгында жеткирүүчүнү жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_warehouse: "Сиз чындыгында скаладды жок кылгыңыз келеби?",
    artikul: "Артикул",
    available_for_sale: "Сатуу үчүн жеткиликтүү",
    bank_requisites: "Банк реквизиттери",
    barcode: "Штрихкод",
    beginning_balance: "Баштапкы калдык",
    bin: "БИН",
    branch: "Филиал",
    bulk_addition: "Топ менен кошуу",
    by_categories: "Категориялар боюнча",
    consumption: "Чыгым",
    consumption_manual: "Кол менен чыгым",
    contact_person: "Байланышуучу адам",
    contragent: "Контрагент",
    cost: "Баасы",
    created: "Түзүлгөн",
    current_stock: "Учурдагы калдык",
    default_for_sale: "Сатуу үчүн демейки катары колдонуңуз",
    default_for_writeoff: "Материалдык жазуу үчүн демейки катары колдонуңуз",
    destination: "Максат",
    details: "Деталдар",
    difference: "Айырма",
    documents: "Документтер",
    draft: "Черновик",
    enter_title_or_barcode: "Аталышын же штрих-кодун киргизиңиз",
    factual_amount: "Иш жүзүндөгү сан",
    finished: "Өткөрүлдү",
    finished2: "Аякталды",
    found_similar_material: "Окшош материал табылган",
    from: "кимден",
    from_warehouse: "Складдан көчүү",
    from_where: "Кайдан",
    general_price: "Жалпы сумма",
    general_stock: "Жалпы калдык",
    group: "Топ",
    groups: "Топтор",
    id: "Id",
    in_warehouse: "Складда",
    inventarization: "Инвентаризациялоо",
    kit: "Топтом",
    Kit: "Топтом",
    kits: "Топтомдор",
    material: "Материал",
    materialgroup: "Топа",
    materials: "Материалдар",
    materialstock: "Материал",
    movement: "Көчүү",
    movement_from: "Көчүү",
    movement_to: "Көчүү",
    movements: "Кыймылдар",
    nomenclature: "Номенклатура",
    not_enough_material: "Материал жетишсиз",
    notify_when_stock: "Калдык болгон учурда билдирүү",
    on_visit_close: "Сапар жабылганда",
    on_visit_save: "Сапарды сактап жатканда",
    operation: "Операция",
    parent_category: "Ата-эне категориясы",
    parent_group: "Ата-эне  тобу",
    physical: "Физикалык",
    price_will_be_used_automatically_from_addition: "Баа алуу документинен автоматтык түрдө колдонулат",
    print: "Басып чыгаруу",
    prohibit_minus_stocks: "Материалдарды минус катары эсептен чыгарууга тыюу салынат",
    prohibit_minus_stocks_in_warehouse_documents: "Бул жөндөө \"Склад\" бөлүмүндө документтерди толтурууда материалдарды минус катары эсептен чыгарууга тыюу салат",
    prohibit_minus_stocks_on_visit_closing: "Визиттин материалдарын минус катары эсептен чыгарууга тыюу салуу (визиттин аяктоосуна тыюу салуу)",
    purchase_price: "Сатып алуу баасы",
    return: "Кайтаруу",
    returns: "Кайтаруулар",
    sale_of_goods_refund: "Товарларды сатуунун кайтарылышы",
    sale_price: "Сатуу баасы",
    stocks: "Калдыктар",
    stocks_archive: "Материалдардын архиви",
    supplier: "Жеткирүүчү",
    suppliers: "Жеткирүүчүлөр",
    to_warehouse: "Складка көчүү",
    to_where: "Кайда",
    trying_to_writeoff: "Жазуу аракети",
    type: "Түрү",
    unit_of_measure: "Өлчөө бирдиктери.",
    virtual: "Виртуалдык",
    warehouse_amount: "Складдагы саны",
    warehouseoperation: "Операциялар",
    warehouses: "Складдар",
    write_off: "Эсептен чыгаруу",
    write_off_materials: "Материалдарды жазуу"
}
